var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "world-delivery" }, [
    _c(
      "a",
      {
        staticClass: "world-delivery__link",
        attrs: { href: _vm.href, target: _vm.target }
      },
      [
        _c("icon", {
          staticClass: "world-delivery__icon",
          attrs: { name: "world", width: "16", height: "16" }
        }),
        _vm._v(" "),
        _c(
          "span",
          { staticClass: "world-delivery__text" },
          [_vm._t("default")],
          2
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }